const options = {
  auto: "aspect-auto",
  square: "aspect-square",
  video: "aspect-video",
  none: "aspect-none",
  "16/1": "aspect-[16/1]",
  "16/2": "aspect-[16/2]",
  "16/3": "aspect-[16/3]",
  "16/4": "aspect-[16/4]",
  "16/5": "aspect-[16/5]",
  "16/6": "aspect-[16/6]",
  "16/7": "aspect-[16/7]",
  "16/8": "aspect-[16/8]",
  "16/9": "aspect-[16/9]",
  "16/10": "aspect-[16/10]",
  "16/11": "aspect-[16/11]",
  "16/12": "aspect-[16/12]",
  "16/13": "aspect-[16/13]",
  "16/14": "aspect-[16/14]",
  "16/15": "aspect-[16/15]",
  "16/16": "aspect-[16/16]",
  "15/1": "aspect-[15/1]",
  "15/2": "aspect-[15/2]",
  "15/3": "aspect-[15/3]",
  "15/4": "aspect-[15/4]",
  "15/5": "aspect-[15/5]",
  "15/6": "aspect-[15/6]",
  "15/7": "aspect-[15/7]",
  "15/8": "aspect-[15/8]",
  "15/9": "aspect-[15/9]",
  "15/10": "aspect-[15/10]",
  "15/11": "aspect-[15/11]",
  "15/12": "aspect-[15/12]",
  "15/13": "aspect-[15/13]",
  "15/14": "aspect-[15/14]",
  "15/15": "aspect-[15/15]",
  "15/16": "aspect-[15/16]",
  "14/1": "aspect-[14/1]",
  "14/2": "aspect-[14/2]",
  "14/3": "aspect-[14/3]",
  "14/4": "aspect-[14/4]",
  "14/5": "aspect-[14/5]",
  "14/6": "aspect-[14/6]",
  "14/7": "aspect-[14/7]",
  "14/8": "aspect-[14/8]",
  "14/9": "aspect-[14/9]",
  "14/10": "aspect-[14/10]",
  "14/11": "aspect-[14/11]",
  "14/12": "aspect-[14/12]",
  "14/13": "aspect-[14/13]",
  "14/14": "aspect-[14/14]",
  "14/15": "aspect-[14/15]",
  "14/16": "aspect-[14/16]",
  "13/1": "aspect-[13/1]",
  "13/2": "aspect-[13/2]",
  "13/3": "aspect-[13/3]",
  "13/4": "aspect-[13/4]",
  "13/5": "aspect-[13/5]",
  "13/6": "aspect-[13/6]",
  "13/7": "aspect-[13/7]",
  "13/8": "aspect-[13/8]",
  "13/9": "aspect-[13/9]",
  "13/10": "aspect-[13/10]",
  "13/11": "aspect-[13/11]",
  "13/12": "aspect-[13/12]",
  "13/13": "aspect-[13/13]",
  "13/14": "aspect-[13/14]",
  "13/15": "aspect-[13/15]",
  "13/16": "aspect-[13/16]",
  "12/1": "aspect-[12/1]",
  "12/2": "aspect-[12/2]",
  "12/3": "aspect-[12/3]",
  "12/4": "aspect-[12/4]",
  "12/5": "aspect-[12/5]",
  "12/6": "aspect-[12/6]",
  "12/7": "aspect-[12/7]",
  "12/8": "aspect-[12/8]",
  "12/9": "aspect-[12/9]",
  "12/10": "aspect-[12/10]",
  "12/11": "aspect-[12/11]",
  "12/12": "aspect-[12/12]",
  "12/13": "aspect-[12/13]",
  "12/14": "aspect-[12/14]",
  "12/15": "aspect-[12/15]",
  "12/16": "aspect-[12/16]",
  "11/1": "aspect-[11/1]",
  "11/2": "aspect-[11/2]",
  "11/3": "aspect-[11/3]",
  "11/4": "aspect-[11/4]",
  "11/5": "aspect-[11/5]",
  "11/6": "aspect-[11/6]",
  "11/7": "aspect-[11/7]",
  "11/8": "aspect-[11/8]",
  "11/9": "aspect-[11/9]",
  "11/10": "aspect-[11/10]",
  "11/11": "aspect-[11/11]",
  "11/12": "aspect-[11/12]",
  "11/13": "aspect-[11/13]",
  "11/14": "aspect-[11/14]",
  "11/15": "aspect-[11/15]",
  "11/16": "aspect-[11/16]",
  "10/1": "aspect-[10/1]",
  "10/2": "aspect-[10/2]",
  "10/3": "aspect-[10/3]",
  "10/4": "aspect-[10/4]",
  "10/5": "aspect-[10/5]",
  "10/6": "aspect-[10/6]",
  "10/7": "aspect-[10/7]",
  "10/8": "aspect-[10/8]",
  "10/9": "aspect-[10/9]",
  "10/10": "aspect-[10/10]",
  "10/11": "aspect-[10/11]",
  "10/12": "aspect-[10/12]",
  "10/13": "aspect-[10/13]",
  "10/14": "aspect-[10/14]",
  "10/15": "aspect-[10/15]",
  "10/16": "aspect-[10/16]",
  "9/1": "aspect-[9/1]",
  "9/2": "aspect-[9/2]",
  "9/3": "aspect-[9/3]",
  "9/4": "aspect-[9/4]",
  "9/5": "aspect-[9/5]",
  "9/6": "aspect-[9/6]",
  "9/7": "aspect-[9/7]",
  "9/8": "aspect-[9/8]",
  "9/9": "aspect-[9/9]",
  "9/10": "aspect-[9/10]",
  "9/11": "aspect-[9/11]",
  "9/12": "aspect-[9/12]",
  "9/13": "aspect-[9/13]",
  "9/14": "aspect-[9/14]",
  "9/15": "aspect-[9/15]",
  "9/16": "aspect-[9/16]",
  "8/1": "aspect-[8/1]",
  "8/2": "aspect-[8/2]",
  "8/3": "aspect-[8/3]",
  "8/4": "aspect-[8/4]",
  "8/5": "aspect-[8/5]",
  "8/6": "aspect-[8/6]",
  "8/7": "aspect-[8/7]",
  "8/8": "aspect-[8/8]",
  "8/9": "aspect-[8/9]",
  "8/10": "aspect-[8/10]",
  "8/11": "aspect-[8/11]",
  "8/12": "aspect-[8/12]",
  "8/13": "aspect-[8/13]",
  "8/14": "aspect-[8/14]",
  "8/15": "aspect-[8/15]",
  "8/16": "aspect-[8/16]",
  "7/1": "aspect-[7/1]",
  "7/2": "aspect-[7/2]",
  "7/3": "aspect-[7/3]",
  "7/4": "aspect-[7/4]",
  "7/5": "aspect-[7/5]",
  "7/6": "aspect-[7/6]",
  "7/7": "aspect-[7/7]",
  "7/8": "aspect-[7/8]",
  "7/9": "aspect-[7/9]",
  "7/10": "aspect-[7/10]",
  "7/11": "aspect-[7/11]",
  "7/12": "aspect-[7/12]",
  "7/13": "aspect-[7/13]",
  "7/14": "aspect-[7/14]",
  "7/15": "aspect-[7/15]",
  "7/16": "aspect-[7/16]",
  "6/1": "aspect-[6/1]",
  "6/2": "aspect-[6/2]",
  "6/3": "aspect-[6/3]",
  "6/4": "aspect-[6/4]",
  "6/5": "aspect-[6/5]",
  "6/6": "aspect-[6/6]",
  "6/7": "aspect-[6/7]",
  "6/8": "aspect-[6/8]",
  "6/9": "aspect-[6/9]",
  "6/10": "aspect-[6/10]",
  "6/11": "aspect-[6/11]",
  "6/12": "aspect-[6/12]",
  "6/13": "aspect-[6/13]",
  "6/14": "aspect-[6/14]",
  "6/15": "aspect-[6/15]",
  "6/16": "aspect-[6/16]",
  "5/1": "aspect-[5/1]",
  "5/2": "aspect-[5/2]",
  "5/3": "aspect-[5/3]",
  "5/4": "aspect-[5/4]",
  "5/5": "aspect-[5/5]",
  "5/6": "aspect-[5/6]",
  "5/7": "aspect-[5/7]",
  "5/8": "aspect-[5/8]",
  "5/9": "aspect-[5/9]",
  "5/10": "aspect-[5/10]",
  "5/11": "aspect-[5/11]",
  "5/12": "aspect-[5/12]",
  "5/13": "aspect-[5/13]",
  "5/14": "aspect-[5/14]",
  "5/15": "aspect-[5/15]",
  "5/16": "aspect-[5/16]",
  "4/1": "aspect-[4/1]",
  "4/2": "aspect-[4/2]",
  "4/3": "aspect-[4/3]",
  "4/4": "aspect-[4/4]",
  "4/5": "aspect-[4/5]",
  "4/6": "aspect-[4/6]",
  "4/7": "aspect-[4/7]",
  "4/8": "aspect-[4/8]",
  "4/9": "aspect-[4/9]",
  "4/10": "aspect-[4/10]",
  "4/11": "aspect-[4/11]",
  "4/12": "aspect-[4/12]",
  "4/13": "aspect-[4/13]",
  "4/14": "aspect-[4/14]",
  "4/15": "aspect-[4/15]",
  "4/16": "aspect-[4/16]",
  "3/1": "aspect-[3/1]",
  "3/2": "aspect-[3/2]",
  "3/3": "aspect-[3/3]",
  "3/4": "aspect-[3/4]",
  "3/5": "aspect-[3/5]",
  "3/6": "aspect-[3/6]",
  "3/7": "aspect-[3/7]",
  "3/8": "aspect-[3/8]",
  "3/9": "aspect-[3/9]",
  "3/10": "aspect-[3/10]",
  "3/11": "aspect-[3/11]",
  "3/12": "aspect-[3/12]",
  "3/13": "aspect-[3/13]",
  "3/14": "aspect-[3/14]",
  "3/15": "aspect-[3/15]",
  "3/16": "aspect-[3/16]",
  "2/1": "aspect-[2/1]",
  "2/2": "aspect-[2/2]",
  "2/3": "aspect-[2/3]",
  "2/4": "aspect-[2/4]",
  "2/5": "aspect-[2/5]",
  "2/6": "aspect-[2/6]",
  "2/7": "aspect-[2/7]",
  "2/8": "aspect-[2/8]",
  "2/9": "aspect-[2/9]",
  "2/10": "aspect-[2/10]",
  "2/11": "aspect-[2/11]",
  "2/12": "aspect-[2/12]",
  "2/13": "aspect-[2/13]",
  "2/14": "aspect-[2/14]",
  "2/15": "aspect-[2/15]",
  "2/16": "aspect-[2/16]",
  "1/1": "aspect-[1/1]",
  "1/2": "aspect-[1/2]",
  "1/3": "aspect-[1/3]",
  "1/4": "aspect-[1/4]",
  "1/5": "aspect-[1/5]",
  "1/6": "aspect-[1/6]",
  "1/7": "aspect-[1/7]",
  "1/8": "aspect-[1/8]",
  "1/9": "aspect-[1/9]",
  "1/10": "aspect-[1/10]",
  "1/11": "aspect-[1/11]",
  "1/12": "aspect-[1/12]",
  "1/13": "aspect-[1/13]",
  "1/14": "aspect-[1/14]",
  "1/15": "aspect-[1/15]",
  "1/16": "aspect-[1/16]",
};

export default function getAspectRatio(attrs) {
  const { aspectH, aspectW } = attrs || {};
  return options[aspectW] || options[aspectH] || options[`${aspectW}/${aspectH}`];
}
